// 权限拦截 导航守卫 路由守卫  router
import router from '@/router' // 引入路由实例
import store from '@/store' // 引入vuex store实例
import NProgress from 'nprogress' // 引入一份进度条插件
import 'nprogress/nprogress.css' // 引入进度条样式

const whiteList = [// 定义白名单  所有不受权限控制的页面
  '/login',
  '/regist',
  '/forget_password',
  '/approval_no',
  '/approval_ing',
  '/enterprise_information/set_enterprise',
  // '/enterprise_information/set_standard'  //企业修改与一标三实合为一个页面
]
// 路由的前置守卫
router.beforeEach(async (to, from, next) => {
  NProgress.start() // 开启进度条
  // 首先判断有无token
  if (store.getters.token) {
    // 如果有token 继续判断是不是去登录页
    if (store.getters.status == 1) {
      if (to.path === '/login') {
        //  表示去的是登录页
        next('/') // 跳到主页
      } else {

        // 判断有无权限
        if (store.getters.menus && store.getters.permission && store.getters.permission.length > 0) {
          if (store.getters.permission.includes(to.path) || to.path === '/404') {
            // 如果跳转的页面在权限内,则跳转
            next()
          } else {
            // 没有则跳转404
            next('/404')
          }

          next()
        } else {
          // 如果没有则重新获取
          await store.dispatch('user/getUserInfo')

          next()
        }
      }
    } else {
      if (whiteList.indexOf(to.path) > -1) {
        // 如果找到了 表示在在名单里面
        console.log('111', to.path);
        next()
      } else {
        next('/login') // 跳到登录页
      }
    }

  } else {
    // 如果没有token
    if (whiteList.indexOf(to.path) > -1) {
      // 如果找到了 表示在在名单里面
      next()
    } else {
      next('/login') // 跳到登录页
    }
  }

  NProgress.done() // 手动强制关闭一次  为了解决 手动切换地址时  进度条的不关闭的问题
})
// 后置守卫
router.afterEach(function () {
  NProgress.done() // 关闭进度条
})
